export default __webpack_public_path__ + "static/media/mba.ef9cd12b.jpg";